import { SVGProps } from 'react';

export const AddIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 8.11111H9.88889V1H8.11111V8.11111H1V9.88889H8.11111V17H9.88889V9.88889H17V8.11111Z"
      fill="currentColor"
    />
  </svg>
);
